import { ThunkAction } from 'redux-thunk';
import { Action } from '../definitions/types';

// tslint:disable-next-line no-any
export type AmbiguousAction = ThunkAction<any, any, any> | Action<any>;

// tslint:disable-next-line no-any
const isAction = (action: AmbiguousAction): boolean => {
  return typeof action !== 'function';
};

export default isAction;
